import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import CityPage from "@/pages/CityPage";
import BusinessPage from "@/pages/BusinessPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCities from "@/pages/admin/AdminCities";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminPackages from "@/pages/admin/AdminPackages";
import AdminListings from "@/pages/admin/AdminListings";
import AdminShowcase from "@/pages/admin/AdminShowcase";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<HomePage />} />
            
            {/* Admin Login - MUST be before dynamic routes */}
            <Route path="/pasteladmin/login" element={<AdminLogin />} />
            
            {/* Protected Admin Routes - MUST be before dynamic routes */}
            <Route path="/pasteladmin" element={<AdminLayout />}>
              <Route index element={<AdminDashboard />} />
              <Route path="cities" element={<AdminCities />} />
              <Route path="categories" element={<AdminCategories />} />
              <Route path="packages" element={<AdminPackages />} />
              <Route path="listings" element={<AdminListings />} />
              <Route path="showcase" element={<AdminShowcase />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
            
            {/* Dynamic city/business routes - MUST be LAST */}
            <Route path="/:citySlug" element={<CityPage />} />
            <Route path="/:citySlug/:businessSlug" element={<BusinessPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
